export enum Locale {
  en = "EN",
  my = "MY",
}